import { Devolucion } from './devolucion';
import { Bonomove } from "./bonomove";
import { Cliente } from "./cliente";
import { FinanciacionPago } from "./financiacion";
import { Ticket } from "./ticket";

export class PrintPagoHelper {
  cliente!: Cliente | null;

  ticket!: Ticket | null;
  financiacionPago!: FinanciacionPago | null;
  bonomove!: Bonomove | null;
  devolucion!: Devolucion | null;

  mensajeOk!: string | null;
  totalPagar!: number | null;

  financiado!: number | null;
  conEfectivo!: boolean | null;
  conTarjeta!: boolean | null;
  importeEfectivo!: number | null;
  importeTarjeta!: number | null;
  efectivoEntregado!: number | null;
  cambioDevuelto!: number | null;
  importeOtros!: number | null;
  conOtros!: boolean | null;

  // Para cálculo de IVA en devoluciones
  ivaAplicado!: number | null;
  totalSinIva!: number | null;
  totalIva!: number | null;

  constructor(init?: Partial<PrintPagoHelper>) {
    Object.assign(this, init);
  }

  static desdePago(
    objeto: Ticket | Bonomove | FinanciacionPago | Devolucion,
    tipo: TipoPago,
    mensajeOk?: string
  ): PrintPagoHelper {
    const helper = new PrintPagoHelper();

    helper.mensajeOk = mensajeOk ?? null;

    // Datos según tipo
    switch (tipo) {
      case TipoPago.Ticket:
        helper.ticket = objeto as Ticket;
        helper.cliente = (objeto as Ticket).cliente ?? null;
        helper.totalPagar = (objeto as Ticket).totalAPagar ?? null;

        // Calcular importe financiado desde los servicios si no está disponible directamente
        const importeFinanciadoTicket = (objeto as Ticket).importeFinanciado;
        if (importeFinanciadoTicket != null && importeFinanciadoTicket > 0) {
          helper.financiado = importeFinanciadoTicket;
        } else {
          // Calcular desde los servicios financiados
          helper.financiado = this.calcularImporteFinanciadoDesdeServicios(objeto as Ticket);
        }
        break;

      case TipoPago.Bonomove:
        helper.bonomove = objeto as Bonomove;
        helper.financiado = (objeto as Bonomove).pagoFinanciado ? (objeto as Bonomove).quedaPorPagar : null;
        helper.cliente = (objeto as Bonomove).cliente ?? null;
        helper.totalPagar = (objeto as Bonomove).totalAPagar ?? null
        break;

      case TipoPago.Financiacion:
        helper.financiacionPago = objeto as FinanciacionPago;
        helper.cliente = (objeto as FinanciacionPago).financiacion.cliente ?? null;
        helper.totalPagar = (objeto as FinanciacionPago).pagadoEnPlazo ?? null;
        break;

      case TipoPago.Devolucion:
        helper.devolucion = objeto as Devolucion;
        helper.cliente = (objeto as Devolucion).cliente ?? null;
        helper.totalPagar = (objeto as Devolucion).importe ?? null;
        break;
    }

    // Datos de pago comunes si existen
    Object.assign(helper, {
      conEfectivo: (objeto as any).conEfectivo ?? null,
      conTarjeta: (objeto as any).conTarjeta ?? null,
      conOtros: (objeto as any).conOtros ?? null,
      importeEfectivo: (objeto as any).importeEfectivo ?? null,
      importeTarjeta: (objeto as any).importeTarjeta ?? null,
      importeOtros: (objeto as any).importeOtros ?? null,
      efectivoEntregado: (objeto as any).efectivoEntregado ?? null,
      cambioDevuelto: (objeto as any).cambioDevuelto ?? null
    });

    return helper;
  }

  /**
   * Crea un PrintPagoHelper específico para devoluciones con cálculo de IVA
   */
  static desdeDevolucion(devolucion: Devolucion, ivaAplicado: number = 21): PrintPagoHelper {
    const helper = PrintPagoHelper.desdePago(devolucion, TipoPago.Devolucion);

    // Calcular IVA (ivaAplicado viene como porcentaje, ej: 21)
    const ivaPorcentaje = ivaAplicado / 100;
    helper.ivaAplicado = ivaPorcentaje;

    // Calcular totales con IVA
    const importeTotal = devolucion.importe || 0;
    helper.totalSinIva = importeTotal / (1 + ivaPorcentaje);
    helper.totalIva = importeTotal - helper.totalSinIva;

    helper.cliente = devolucion.cliente;

    return helper;
  }

  /**
   * Calcula el importe financiado total sumando todos los servicios financiados del ticket
   */
  private static calcularImporteFinanciadoDesdeServicios(ticket: Ticket): number {
    if (!ticket.event?.eventServicios) {
      return 0;
    }

    let totalFinanciado = 0;

    // Recorrer cada servicio del evento
    for (const eventServicio of ticket.event.eventServicios) {
      if (eventServicio.eventServicioDetalles) {
        // Recorrer cada detalle del servicio
        for (const detalle of eventServicio.eventServicioDetalles) {
          // Si el detalle está financiado (financiado = 1)
          if (detalle.financiado === 1) {
            // El importe financiado es el precio total del servicio menos lo cobrado ahora (precioPlazo)
            const precioTotal = eventServicio.servicioPrize || 0;
            const precioCobradoAhora = detalle.precioPlazo || 0;
            const importeFinanciadoServicio = precioTotal - precioCobradoAhora;

            if (importeFinanciadoServicio > 0) {
              totalFinanciado += importeFinanciadoServicio;
            }
          }
        }
      }
    }

    return totalFinanciado > 0 ? totalFinanciado : 0;
  }
}

export enum TipoPago {
  Ticket = 'ticket',
  Bonomove = 'bonomove',
  Financiacion = 'financiacion',
  Devolucion = 'devolucion',
  Desconocido = 'desconocido'
}
